import { ImportConfig } from '../components/Common/ImportModal';

// =============================================
// CONFIGURAÇÕES DE IMPORTAÇÃO POR ENTIDADE
// =============================================

export const obrasImportConfig: ImportConfig = {
  entityName: 'Obras',
  entityKey: 'obras',
  columns: [
    { header: 'Número da Obra', field: 'numero_obra', required: true, type: 'string', example: 'OBR-001' },
    { header: 'Nome', field: 'nome', required: true, type: 'string', example: 'Edifício Residencial Solar' },
    { header: 'Categoria', field: 'categoria', required: true, type: 'string', example: 'residencial' },
    { header: 'Descrição', field: 'descricao', required: false, type: 'string', example: 'Construção de edifício 20 andares' },
    { header: 'Cliente - Nome', field: 'cliente_nome', required: false, type: 'string', example: 'Construtora ABC Ltda' },
    { header: 'Cliente - CNPJ', field: 'cliente_cnpj', required: false, type: 'string', example: '12.345.678/0001-90' },
    { header: 'Cliente - Contato', field: 'cliente_contato', required: false, type: 'string', example: '(11) 99999-0000' },
    { header: 'Responsável Técnico - Nome', field: 'responsavel_tecnico_nome', required: false, type: 'string', example: 'Eng. João Silva' },
    { header: 'Responsável Técnico - CREA', field: 'responsavel_tecnico_crea', required: false, type: 'string', example: 'CREA-SP 123456' },
    { header: 'Responsável Técnico - Contato', field: 'responsavel_tecnico_contato', required: false, type: 'string', example: '(11) 98888-0000' },
    { header: 'Endereço - Logradouro', field: 'endereco_logradouro', required: false, type: 'string', example: 'Rua das Flores' },
    { header: 'Endereço - Número', field: 'endereco_numero', required: false, type: 'string', example: '100' },
    { header: 'Endereço - Complemento', field: 'endereco_complemento', required: false, type: 'string', example: 'Bloco A' },
    { header: 'Endereço - Bairro', field: 'endereco_bairro', required: false, type: 'string', example: 'Centro' },
    { header: 'Endereço - Cidade', field: 'endereco_cidade', required: false, type: 'string', example: 'São Paulo' },
    { header: 'Endereço - Estado', field: 'endereco_estado', required: false, type: 'string', example: 'SP' },
    { header: 'Endereço - CEP', field: 'endereco_cep', required: false, type: 'string', example: '01001-000' },
    { header: 'Data Início Prevista', field: 'data_inicio_prevista', required: false, type: 'date', example: '01/03/2026' },
    { header: 'Data Fim Prevista', field: 'data_fim_prevista', required: false, type: 'date', example: '01/03/2027' },
    { header: 'Data Início Contrato', field: 'data_inicio_contrato', required: false, type: 'date', example: '15/02/2026' },
    { header: 'Data Fim Contrato', field: 'data_fim_contrato', required: false, type: 'date', example: '15/02/2027' },
    { header: 'Valor Total', field: 'valor_total', required: false, type: 'decimal', example: '1500000.00' },
    { header: 'Moeda', field: 'moeda', required: false, type: 'string', example: 'BRL' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'planejamento' },
    { header: 'Percentual Conclusão', field: 'percentual_conclusao', required: false, type: 'number', example: '0' },
    { header: 'Observações', field: 'observacoes', required: false, type: 'string', example: '' },
  ],
  exampleRows: [
    {
      'Número da Obra*': 'OBR-001', 'Nome*': 'Edifício Residencial Solar', 'Categoria*': 'residencial',
      'Descrição': 'Construção de edifício 20 andares', 'Cliente - Nome': 'Construtora ABC Ltda',
      'Cliente - CNPJ': '12.345.678/0001-90', 'Endereço - Cidade': 'São Paulo', 'Endereço - Estado': 'SP',
      'Data Início Prevista': '01/03/2026', 'Valor Total': '1500000.00', 'Status': 'planejamento',
    },
    {
      'Número da Obra*': 'OBR-002', 'Nome*': 'Galpão Industrial Norte', 'Categoria*': 'industrial',
      'Descrição': 'Galpão logístico 5000m²', 'Cliente - Nome': 'Logística Express',
      'Endereço - Cidade': 'Campinas', 'Endereço - Estado': 'SP',
      'Data Início Prevista': '15/04/2026', 'Valor Total': '800000.00', 'Status': 'ativo',
    },
    {
      'Número da Obra*': 'OBR-003', 'Nome*': 'Reforma Escritório Central', 'Categoria*': 'reforma',
      'Descrição': 'Reforma completa do 5º andar', 'Cliente - Nome': 'Tech Solutions SA',
      'Endereço - Cidade': 'Rio de Janeiro', 'Endereço - Estado': 'RJ',
      'Data Início Prevista': '01/06/2026', 'Valor Total': '350000.00', 'Status': 'planejamento',
    },
  ],
};

export const veiculosImportConfig: ImportConfig = {
  entityName: 'Veículos',
  entityKey: 'veiculos',
  columns: [
    { header: 'Placa', field: 'placa', required: true, type: 'string', example: 'ABC1D23' },
    { header: 'Tag', field: 'tag', required: false, type: 'string', example: 'VEI-001' },
    { header: 'Renavam', field: 'renavam', required: false, type: 'string', example: '12345678901' },
    { header: 'Chassi', field: 'chassi', required: false, type: 'string', example: '9BWZZZ377VT004251' },
    { header: 'Marca', field: 'marca', required: false, type: 'string', example: 'Volkswagen' },
    { header: 'Modelo', field: 'modelo', required: false, type: 'string', example: 'Constellation 24.280' },
    { header: 'Tipo', field: 'tipo', required: false, type: 'string', example: 'Caminhão' },
    { header: 'Ano Fabricação', field: 'ano_fabricacao', required: false, type: 'number', example: '2024' },
    { header: 'Ano Modelo', field: 'ano_modelo', required: false, type: 'number', example: '2025' },
    { header: 'Cor', field: 'cor', required: false, type: 'string', example: 'Branco' },
    { header: 'Combustível', field: 'combustivel', required: false, type: 'string', example: 'Diesel' },
    { header: 'Categoria', field: 'categoria', required: false, type: 'string', example: 'Pesado' },
    { header: 'Capacidade Tanque', field: 'capacidade_tanque', required: false, type: 'decimal', example: '300' },
    { header: 'Quilometragem Atual', field: 'quilometragem_atual', required: false, type: 'number', example: '15000' },
    { header: 'Número Motor', field: 'numero_motor', required: false, type: 'string', example: 'MTR123456' },
    { header: 'Potência', field: 'potencia', required: false, type: 'string', example: '280 CV' },
    { header: 'Peso Bruto', field: 'peso_bruto', required: false, type: 'decimal', example: '23000' },
    { header: 'Capacidade Carga', field: 'capacidade_carga', required: false, type: 'decimal', example: '16000' },
    { header: 'Número Passageiros', field: 'numero_passageiros', required: false, type: 'number', example: '2' },
    { header: 'Proprietário', field: 'proprietario', required: false, type: 'string', example: 'Transportes XYZ' },
    { header: 'Data Aquisição', field: 'data_aquisicao', required: false, type: 'date', example: '10/01/2024' },
    { header: 'Observações', field: 'observacoes', required: false, type: 'string', example: '' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'ativo' },
    { header: 'Centro Custo', field: 'centro_custo', required: false, type: 'string', example: 'CC-001' },
    { header: 'Departamento Responsável', field: 'departamento_responsavel', required: false, type: 'string', example: 'Logística' },
  ],
  exampleRows: [
    {
      'Placa*': 'ABC1D23', 'Marca': 'Volkswagen', 'Modelo': 'Constellation 24.280',
      'Tipo': 'Caminhão', 'Ano Fabricação': '2024', 'Cor': 'Branco',
      'Combustível': 'Diesel', 'Quilometragem Atual': '15000', 'Status': 'ativo',
    },
    {
      'Placa*': 'DEF2G45', 'Marca': 'Mercedes-Benz', 'Modelo': 'Actros 2651',
      'Tipo': 'Cavalo Mecânico', 'Ano Fabricação': '2023', 'Cor': 'Prata',
      'Combustível': 'Diesel', 'Quilometragem Atual': '45000', 'Status': 'ativo',
    },
    {
      'Placa*': 'GHI3J67', 'Marca': 'Fiat', 'Modelo': 'Strada Freedom',
      'Tipo': 'Utilitário', 'Ano Fabricação': '2025', 'Cor': 'Vermelho',
      'Combustível': 'Flex', 'Quilometragem Atual': '500', 'Status': 'ativo',
    },
  ],
};

export const motoristasImportConfig: ImportConfig = {
  entityName: 'Motoristas',
  entityKey: 'motoristas',
  columns: [
    { header: 'Nome', field: 'nome', required: true, type: 'string', example: 'João da Silva' },
    { header: 'CPF', field: 'cpf', required: true, type: 'string', example: '123.456.789-00' },
    { header: 'CNH Número', field: 'cnh_numero', required: true, type: 'string', example: '12345678901' },
    { header: 'RG', field: 'rg', required: false, type: 'string', example: '12.345.678-9' },
    { header: 'Data Nascimento', field: 'data_nascimento', required: false, type: 'date', example: '15/06/1985' },
    { header: 'Telefone', field: 'telefone', required: false, type: 'string', example: '(11) 3333-4444' },
    { header: 'Celular', field: 'celular', required: false, type: 'string', example: '(11) 99999-8888' },
    { header: 'E-mail', field: 'email', required: false, type: 'string', example: 'joao.silva@email.com' },
    { header: 'Endereço - Rua', field: 'endereco_rua', required: false, type: 'string', example: 'Rua das Palmeiras' },
    { header: 'Endereço - Número', field: 'endereco_numero', required: false, type: 'string', example: '250' },
    { header: 'Endereço - Complemento', field: 'endereco_complemento', required: false, type: 'string', example: 'Apto 12' },
    { header: 'Endereço - Bairro', field: 'endereco_bairro', required: false, type: 'string', example: 'Jardim América' },
    { header: 'Endereço - Cidade', field: 'endereco_cidade', required: false, type: 'string', example: 'São Paulo' },
    { header: 'Endereço - Estado', field: 'endereco_estado', required: false, type: 'string', example: 'SP' },
    { header: 'Endereço - CEP', field: 'endereco_cep', required: false, type: 'string', example: '01234-567' },
    { header: 'CNH Categoria', field: 'cnh_categoria', required: false, type: 'string', example: 'E' },
    { header: 'CNH Vencimento', field: 'cnh_vencimento', required: false, type: 'date', example: '20/12/2027' },
    { header: 'CNH Primeira Habilitação', field: 'cnh_primeira_habilitacao', required: false, type: 'date', example: '10/03/2005' },
    { header: 'Contato Emergência - Nome', field: 'contato_emergencia_nome', required: false, type: 'string', example: 'Maria da Silva' },
    { header: 'Contato Emergência - Telefone', field: 'contato_emergencia_telefone', required: false, type: 'string', example: '(11) 98877-6655' },
    { header: 'Contato Emergência - Parentesco', field: 'contato_emergencia_parentesco', required: false, type: 'string', example: 'Esposa' },
    { header: 'Data Admissão', field: 'data_admissao', required: false, type: 'date', example: '01/02/2020' },
    { header: 'Salário', field: 'salario', required: false, type: 'decimal', example: '3500.00' },
    { header: 'Banco', field: 'banco', required: false, type: 'string', example: 'Banco do Brasil' },
    { header: 'Agência', field: 'agencia', required: false, type: 'string', example: '1234-5' },
    { header: 'Conta', field: 'conta', required: false, type: 'string', example: '12345-6' },
    { header: 'Chave PIX', field: 'pix_chave', required: false, type: 'string', example: '123.456.789-00' },
    { header: 'Observações', field: 'observacoes', required: false, type: 'string', example: '' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'ativo' },
  ],
  exampleRows: [
    {
      'Nome*': 'João da Silva', 'CPF*': '123.456.789-00', 'CNH Número*': '12345678901',
      'Celular': '(11) 99999-8888', 'E-mail': 'joao.silva@email.com',
      'CNH Categoria': 'E', 'CNH Vencimento': '20/12/2027',
      'Data Admissão': '01/02/2020', 'Status': 'ativo',
    },
    {
      'Nome*': 'Carlos Oliveira', 'CPF*': '987.654.321-00', 'CNH Número*': '98765432100',
      'Celular': '(21) 98888-7777', 'E-mail': 'carlos.oliveira@email.com',
      'CNH Categoria': 'D', 'CNH Vencimento': '15/08/2026',
      'Data Admissão': '10/05/2021', 'Status': 'ativo',
    },
    {
      'Nome*': 'Pedro Santos', 'CPF*': '456.789.123-00', 'CNH Número*': '45678912300',
      'Celular': '(31) 97777-6666', 'E-mail': 'pedro.santos@email.com',
      'CNH Categoria': 'C', 'CNH Vencimento': '30/06/2028',
      'Data Admissão': '20/11/2022', 'Status': 'ativo',
    },
  ],
};

export const equipamentosImportConfig: ImportConfig = {
  entityName: 'Equipamentos',
  entityKey: 'equipamentos',
  columns: [
    { header: 'Nome', field: 'nome', required: true, type: 'string', example: 'Betoneira 400L' },
    { header: 'Tag', field: 'tag', required: true, type: 'string', example: 'EQP-001' },
    { header: 'Tipo', field: 'tipo', required: true, type: 'string', example: 'Construção' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'ativo' },
    { header: 'Localização', field: 'localizacao', required: false, type: 'string', example: 'Obra Solar - Pátio' },
    { header: 'Validade', field: 'validade', required: false, type: 'date', example: '30/06/2027' },
    { header: 'Descrição', field: 'descricao', required: false, type: 'string', example: 'Betoneira elétrica 400 litros' },
    { header: 'Responsável', field: 'responsavel', required: false, type: 'string', example: 'José Ferreira' },
    { header: 'Fabricante', field: 'fabricante', required: false, type: 'string', example: 'Menegotti' },
    { header: 'Número de Série', field: 'numero_serie', required: false, type: 'string', example: 'SN-2024-001234' },
    { header: 'Capacidade', field: 'capacidade', required: false, type: 'string', example: '400 litros' },
    { header: 'Código Patrimônio', field: 'codigo_patrimonio', required: false, type: 'string', example: 'PAT-00123' },
  ],
  exampleRows: [
    {
      'Nome*': 'Betoneira 400L', 'Tag*': 'EQP-001', 'Tipo*': 'Construção',
      'Status': 'ativo', 'Localização': 'Obra Solar - Pátio',
      'Fabricante': 'Menegotti', 'Número de Série': 'SN-2024-001234',
    },
    {
      'Nome*': 'Compactador de Solo', 'Tag*': 'EQP-002', 'Tipo*': 'Terraplanagem',
      'Status': 'ativo', 'Localização': 'Galpão Central',
      'Fabricante': 'Wacker Neuson', 'Número de Série': 'SN-2023-005678',
    },
    {
      'Nome*': 'Gerador 100KVA', 'Tag*': 'EQP-003', 'Tipo*': 'Energia',
      'Status': 'manutencao', 'Localização': 'Oficina Manutenção',
      'Fabricante': 'Cummins', 'Número de Série': 'SN-2022-009012',
    },
  ],
};

export const itensChecklistImportConfig: ImportConfig = {
  entityName: 'Itens de Checklist',
  entityKey: 'itens-checklist',
  columns: [
    { header: 'Descrição', field: 'descricao', required: true, type: 'string', example: 'Verificar nível do óleo do motor' },
    { header: 'Categoria', field: 'categoria', required: false, type: 'string', example: 'Motor' },
    { header: 'Tipo', field: 'tipo', required: false, type: 'string', example: 'booleano' },
    { header: 'Obrigatório', field: 'obrigatorio', required: false, type: 'boolean', example: 'Sim' },
    { header: 'Ordem', field: 'ordem', required: false, type: 'number', example: '1' },
    { header: 'Observação', field: 'observacao', required: false, type: 'string', example: 'Verificar com motor frio' },
  ],
  exampleRows: [
    {
      'Descrição*': 'Verificar nível do óleo do motor', 'Categoria': 'Motor',
      'Tipo': 'booleano', 'Obrigatório': 'Sim', 'Ordem': '1',
      'Observação': 'Verificar com motor frio',
    },
    {
      'Descrição*': 'Registrar quilometragem atual', 'Categoria': 'Painel',
      'Tipo': 'numero', 'Obrigatório': 'Sim', 'Ordem': '2',
      'Observação': '',
    },
    {
      'Descrição*': 'Estado dos pneus dianteiros', 'Categoria': 'Pneus',
      'Tipo': 'opcoes', 'Obrigatório': 'Não', 'Ordem': '3',
      'Observação': 'Bom, Regular, Ruim',
    },
  ],
};

export const gruposChecklistImportConfig: ImportConfig = {
  entityName: 'Grupos de Checklist',
  entityKey: 'grupos-checklist',
  columns: [
    { header: 'Nome', field: 'nome', required: true, type: 'string', example: 'Inspeção Diária Veículo' },
    { header: 'Tipo', field: 'tipo', required: true, type: 'string', example: 'Veículo' },
    { header: 'Descrição', field: 'descricao', required: false, type: 'string', example: 'Checklist diário obrigatório' },
    { header: 'Categoria', field: 'categoria', required: false, type: 'string', example: 'Diário' },
    { header: 'Ordem', field: 'ordem', required: false, type: 'number', example: '1' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'Ativo' },
  ],
  exampleRows: [
    {
      'Nome*': 'Inspeção Diária Veículo', 'Tipo*': 'Veículo',
      'Descrição': 'Checklist diário obrigatório antes de sair', 'Categoria': 'Diário',
      'Ordem': '1', 'Status': 'Ativo',
    },
    {
      'Nome*': 'Verificação Documental', 'Tipo*': 'Documental',
      'Descrição': 'Conferência de documentos do veículo e motorista', 'Categoria': 'Semanal',
      'Ordem': '2', 'Status': 'Ativo',
    },
    {
      'Nome*': 'Inspeção de Equipamentos', 'Tipo*': 'Equipamento',
      'Descrição': 'Verificação de equipamentos de segurança', 'Categoria': 'Mensal',
      'Ordem': '3', 'Status': 'Ativo',
    },
  ],
};

export const ocorrenciasImportConfig: ImportConfig = {
  entityName: 'Ocorrências',
  entityKey: 'ocorrencias',
  columns: [
    { header: 'Título', field: 'titulo', required: true, type: 'string', example: 'Pneu furado na BR-101' },
    { header: 'Tipo', field: 'tipo', required: true, type: 'string', example: 'Avaria' },
    { header: 'Descrição', field: 'descricao', required: false, type: 'string', example: 'Pneu dianteiro direito furou no km 230' },
    { header: 'Gravidade', field: 'gravidade', required: false, type: 'string', example: 'Média' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'Pendente' },
    { header: 'Data Ocorrência', field: 'data_ocorrencia', required: false, type: 'date', example: '15/03/2026' },
    { header: 'Local', field: 'local', required: false, type: 'string', example: 'BR-101, km 230 - Florianópolis/SC' },
    { header: 'Responsável', field: 'responsavel', required: false, type: 'string', example: 'Carlos Manutenção' },
    { header: 'Observações Resolução', field: 'observacoes_resolucao', required: false, type: 'string', example: '' },
  ],
  exampleRows: [
    {
      'Título*': 'Pneu furado na BR-101', 'Tipo*': 'Avaria',
      'Descrição': 'Pneu dianteiro direito furou no km 230', 'Gravidade': 'Média',
      'Status': 'Pendente', 'Data Ocorrência': '15/03/2026',
      'Local': 'BR-101, km 230 - Florianópolis/SC',
    },
    {
      'Título*': 'Multa por excesso de velocidade', 'Tipo*': 'Multa',
      'Descrição': 'Auto de infração nº 12345', 'Gravidade': 'Baixa',
      'Status': 'Pendente', 'Data Ocorrência': '10/03/2026',
      'Local': 'Rodovia Anhanguera, km 45',
    },
    {
      'Título*': 'Colisão no estacionamento', 'Tipo*': 'Acidente',
      'Descrição': 'Batida leve ao manobrar no pátio', 'Gravidade': 'Alta',
      'Status': 'Em Andamento', 'Data Ocorrência': '05/03/2026',
      'Local': 'Pátio da empresa - São Paulo',
    },
  ],
};

export const abastecimentosImportConfig: ImportConfig = {
  entityName: 'Abastecimentos',
  entityKey: 'abastecimentos',
  columns: [
    { header: 'Placa Veículo', field: 'placa_veiculo', required: true, type: 'string', example: 'ABC1D23' },
    { header: 'Data Início', field: 'data_inicio', required: true, type: 'date', example: '15/03/2026 08:30' },
    { header: 'Volume (Litros)', field: 'volume', required: true, type: 'decimal', example: '150.5' },
    { header: 'Custo Total', field: 'custo', required: true, type: 'decimal', example: '975.25' },
    { header: 'Tipo Combustível', field: 'tipo_combustivel', required: true, type: 'string', example: 'Diesel S10' },
    { header: 'Data Fim', field: 'data_fim', required: false, type: 'date', example: '15/03/2026 08:45' },
    { header: 'Valor Unitário', field: 'valor_unitario', required: false, type: 'decimal', example: '6.48' },
    { header: 'Odômetro', field: 'odometro', required: false, type: 'number', example: '125430' },
    { header: 'Horímetro', field: 'horimetro', required: false, type: 'number', example: '' },
    { header: 'Posto - Nome', field: 'posto_nome', required: false, type: 'string', example: 'Posto Shell Centro' },
    { header: 'Posto - CNPJ', field: 'posto_cnpj', required: false, type: 'string', example: '11.222.333/0001-44' },
    { header: 'Posto - UF', field: 'posto_uf', required: false, type: 'string', example: 'SP' },
    { header: 'Chave NFe', field: 'chave_nfe', required: false, type: 'string', example: '' },
    { header: 'Observações', field: 'observacoes', required: false, type: 'string', example: 'Tanque cheio' },
    { header: 'Status', field: 'status', required: false, type: 'string', example: 'concluido' },
  ],
  exampleRows: [
    {
      'Placa Veículo*': 'ABC1D23', 'Data Início*': '15/03/2026 08:30',
      'Volume (Litros)*': '150.5', 'Custo Total*': '975.25',
      'Tipo Combustível*': 'Diesel S10', 'Odômetro': '125430',
      'Posto - Nome': 'Posto Shell Centro', 'Status': 'concluido',
    },
    {
      'Placa Veículo*': 'DEF2G45', 'Data Início*': '14/03/2026 14:00',
      'Volume (Litros)*': '200.0', 'Custo Total*': '1296.00',
      'Tipo Combustível*': 'Diesel S500', 'Odômetro': '230100',
      'Posto - Nome': 'Auto Posto BR Rodovia', 'Status': 'concluido',
    },
    {
      'Placa Veículo*': 'GHI3J67', 'Data Início*': '13/03/2026 10:15',
      'Volume (Litros)*': '45.0', 'Custo Total*': '270.00',
      'Tipo Combustível*': 'Gasolina Comum', 'Odômetro': '12500',
      'Posto - Nome': 'Posto Ipiranga Saída', 'Status': 'concluido',
    },
  ],
};
